const locale = window.navigator.language || 'en-US';

const numberFormatter = new Intl.NumberFormat(locale);

export const fixedTwoDecimalNumberFormatter = new Intl.NumberFormat(locale, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const compactNumberFormatter = new Intl.NumberFormat(locale, {
  notation: 'compact',
});

export default numberFormatter;
